<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template><div><div v-if="admin_admin_users">
	<div class="py-4 d-flex align-center">
		<h3 class="mr-3">ADMIN Users:</h3>
		<k-text-field
			v-model="search"
			prepend-inner-icon="fa fa-search" clearable clear-icon="fa fa-times-circle"
			prepend-decorative
			aria-label="Search admin users"
			label="Search" single-line hide-details outlined dense background-color="#fff" style="flex:0 1 350px"
		/>
		<k-btn small class="ml-8" color="#333" dark @click="new_user_clicked">
			<k-icon small class="mr-2">fas fa-plus</k-icon> Add New Admin User
		</k-btn>
	</div>

	<k-data-table
		class="k-admin-users-table"
		:headers="headers"
		:items="rows"
		:sort-by="['su', 'user']"
		:sort-desc="[true, false]"
		:must-sort="true"
		:custom-filter="table_search_filter"
		:search="search"
		:footer-props="footer_options"
		:items-per-page="-1"
		hide-default-footer
		light
	>
		<template v-slot:header.user="{header}">
			<span class="mr-1">User</span>
		</template>

		<template v-slot:header.su="{header}">
			<k-tooltip bottom>
				<template v-slot:activator="{on}">
					<span v-on="on" class="mr-1">SU</span>
				</template>
				Superuser Access
			</k-tooltip>
		</template>

		<template v-slot:header.qs="{header}">
			<k-tooltip bottom>
				<template v-slot:activator="{on}">
					<span v-on="on" class="mr-1">QS</span>
				</template>
				Update “QuickStart” search results
			</k-tooltip>
		</template>

		<template v-slot:header.mimic_all="{header}">
			<k-tooltip bottom>
				<template v-slot:activator="{on}">
					<span v-on="on" class="mr-1">Mimic All</span>
				</template>
				Mimic All Users
			</k-tooltip>
		</template>

		<template v-slot:header.res_rep="{header}">
			<k-tooltip bottom>
				<template v-slot:activator="{on}">
					<span v-on="on" class="mr-1">Resource Report</span>
				</template>
				View Resource Report
			</k-tooltip>
		</template>

		<template v-slot:item="{ item }">
			<tr>
				<td><k-btn icon x-small class="mr-2" accessible-label="Edit admin user" @click="edit_user(item.identifier)"><k-icon>fas fa-edit</k-icon></k-btn><span v-html="item.user"></span></td>
				<td><k-icon v-if="is_su(item)" small>fas fa-check</k-icon></td>
				<td><k-icon v-if="can_mimic_all(item)" small>fas fa-check</k-icon></td>
				<td><k-icon v-if="can_view_resource_report(item)" small>fas fa-check</k-icon></td>
				<td style="width:33%; border-left:1px solid #ccc">
					<k-chip v-for="lp in item.lps" :key="lp.code" x-small class="mr-1">{{lp.text}}</k-chip>
				</td>
				<td style="width:33%; border-left:1px solid #ccc">
					<k-chip v-for="view_lp in item.view_lps" :key="view_lp.code" x-small class="mr-1">{{view_lp.text}}</k-chip>
				</td>
				<td v-if="site_config.show_pd == 'yes'" style="width:33%; border-left:1px solid #ccc">
					<k-chip v-for="com in item.pd_reps" :key="com.code" x-small class="mr-1">{{com.text}}</k-chip>
				</td>
				<td v-if="site_config.asset_manager.enabled" style="width:33%; border-left:1px solid #ccc">
					<k-chip v-for="asset_r in item.assets.reviewer" :key="asset_r.code" x-small class="mr-1">{{asset_r.text}}</k-chip>
				</td>
				<td v-if="site_config.asset_manager.enabled" style="width:33%; border-left:1px solid #ccc">
					<k-chip v-for="asset_p in item.assets.publisher" :key="asset_p.code" x-small class="mr-1">{{asset_p.text}}</k-chip>
				</td>
			</tr>
		</template>
	</k-data-table>
	<AdminUserEdit v-if="user_being_edited" :admin_user="user_being_edited" @editor_cancel="user_being_edited=null" @rights_edited="rights_edited"/>
</div></div></template>

<script>
import { mapState } from 'vuex'
import AdminUserEdit from './AdminUserEdit'

export default {
	components: { AdminUserEdit },
	props: {
		// admin_users: { type: Object, required: true },
	},

	data() { return {
		footer_options: {
			itemsPerPageOptions: [10,50,100,-1],
		},
		search: '',
		user_being_edited: null,
	}},

	computed: {
		...mapState(['user_info', 'all_courses_loaded', 'all_courses', 'site_config', 'todo_user_group_divisions', 'todo_user_group_schools', 'admin_admin_users']),

		headers() {
			let arr = [
				{ text: 'User', align: 'left', sortable: true, value: 'user' },
				{ text: 'SU', align: 'left', sortable: true, value: 'su', width: '65px' },
				{ text: 'Mimic All', align: 'left', sortable: true, value: 'mimic_all' },
				{ text: 'Resource Report', align: 'left', sortable: true, value: 'res_rep' },
				{ text: 'Edit Courses', align: 'center', sortable: false, value: 'lp' },
				{ text: 'View Courses', align: 'center', sortable: false, value: 'view_lp' },
			]
			if (this.site_config.show_pd == 'yes') {
				arr.push({ text: 'PD Reports', align: 'center', sortable: false, value:'pd_rep' })
			}
			if (this.site_config.asset_manager.enabled) {
				arr.push(
					{text: 'Asset Reviewer', align: 'center', sortable: false, value: 'asset_reviewer'},
					{text: 'Asset Publisher', align: 'center', sortable: false, value: 'asset_publisher'}
				)
			}
			return arr
		},

		rows() {
			let arr = []

			for (let identifier in this.admin_admin_users) {
				let u = this.admin_admin_users[identifier]
				let o = {
					identifier: identifier,
					user: sr('$1, $2 ($3)', u.last_name, u.first_name, u.email),
				}
				o.user_lc = o.user.toLowerCase()

				// NOTE THAT CODE BELOW IS LARGELY MIRRORED IN AdminUserEdit.vue
				// if user has su rights, they can do everything else too
				if (u.rights.findIndex(s=>s=='su') > -1) {
					o.su = true
					o.pd = true
					o.pg = true
					o.res_rep = true
					o.lps = [
						{ code: 'lp.level.all', text: 'ALL COURSES', text_lc: 'all courses' },
					]
					o.view_lps = [
						{ code: 'view_lp.level.all', text: 'ALL COURSES', text_lc: 'all courses' },
					]
					o.pd_reps = [
						{ code: 'all', text: 'ALL SCHOOLS/DIVISIONS', text_lc: 'all schools/divisions' },
					]
					o.assets = {
						reviewer: [{code: 'asset_reviewer.all', text: 'ALL COURSES', text_lc: 'all courses'}],
						publisher: [{code: 'asset_publisher.all', text: 'ALL COURSES', text_lc: 'all courses'}]
					}
				} else {
					// else build up list from rights
					o.su = false
					o.pd = false
					o.pg = false
					o.lps = []
					o.view_lps = []
					o.pd_reps = []
					o.assets = {
						reviewer: [],
						publisher: []
					}

					for (var code of u.rights) {
						let lp = /^lp\.(.*?)\.(.*)/.exec(code)
						let view_lp = /^view_lp\.(.*?)\.(.*)/.exec(code)
						let pd_rep = /^pd_rep\.(.*)/.exec(code)
						let asset = /^asset_([a-z]+)\.(.*)\.(.*)/.exec(code)

						if (lp) {
							// Edit courses
							let text = this.get_text(lp[1], lp[2])
							o.lps.push({ code, text, text_lc: text.toLowerCase() })
						} else if (view_lp) {
							// View courses
							let text = this.get_text(view_lp[1], view_lp[2])
							o.view_lps.push({ code, text, text_lc: text.toLowerCase() })
						} else if (pd_rep) {
							// PD reports
							let uuid = pd_rep[1]
							let text
							if (uuid == 'all') {
								text = 'ALL SCHOOLS/DIVISIONS'
							} else {
								if (this.todo_user_group_divisions[uuid]) {
									text = this.todo_user_group_divisions[uuid]
								} else if (this.todo_user_group_schools[uuid]) {
									text = this.todo_user_group_schools[uuid]
								} else {
									text = uuid	// hopefully this won't happen
								}
							}
							o.pd_reps.push({ code, text, text_lc: text.toLowerCase() })
						} else if (asset) {
							// Asset Manager
							let role = asset[1]
							let l1 = asset[2]
							let l2 = asset[3]
							let text = this.get_text(l1, l2)
							o.assets[role].push({code, text})
						} else {
							o[code] = true
						}
					}
				}

				arr.push(o)
			}

			return arr
		},
	},

	created() {
		// DEBUG
		vapp.admin_users_admin_component = this
		console.warn('AdminUsersAdmin created')
		if (empty(this.admin_admin_users)) {
			this.load_admin_user_list()
		}
	},
	
	methods: {
		load_admin_user_list() {
			// we must have all_courses loaded first; then we get the list of admins
			if (!this.all_courses_loaded) {
				this.$store.dispatch('get_all_courses').then(()=>{
					this.load_admin_user_list_2()
				}).catch(()=>{
					this.$alert('error in get_all_courses')
				})
			} else {
				this.load_admin_user_list_2()
			}
		},

		load_admin_user_list_2() {
			let payload = {
				user_id: this.user_info.user_id,
				user_identifier: 'all',
			}
			U.loading_start()
			U.ajax('admin_get_user_admin_rights', payload, result=>{
				U.loading_stop()
				if (result.status != 'ok') {
					console.error('Error in admin ajax call'); vapp.ping(); return;
				}

				this.$store.commit('set', ['admin_admin_users', result.admin_users])
				// format for each admin_user: { user_id, email, first_name, last_name, rights["su", "lp.course.1345", etc.]}
			});
		},

		table_search_filter(value, search, item) {
			// value is the value of the column (we can ignore this); search is the search string (could be empty)
			// RETURN FALSE TO HIDE THE ITEM

			// if search is empty, always return true, so the row will SHOW
			if (empty(search)) return true

			search = search.toLowerCase()
			let re = new RegExp(search, 'i')

			// check user name
			if (item.user_lc.search(re) > -1) return true

			// check lps and view_lps
			for (let lp of item.lps) {
				if (lp.text_lc.search(re) > -1) return true
			}
			for (let view_lp of item.view_lps) {
				if (view_lp.text_lc.search(re) > -1) return true
			}

			// check su
			if (search == 'su' && item.su) return true

			// if we get to here return false
			return false
		},

		edit_user(identifier) {
			this.user_being_edited = this.admin_admin_users[identifier]
		},

		rights_edited(new_rights) {
			let payload = {
				user_id: this.user_info.user_id,
				user_identifier: this.user_being_edited.user_id,
				rights_arr: new_rights,
			}

			U.loading_start()
			U.ajax('admin_update_admin_rights', payload, result=>{
				U.loading_stop()
				if (result.status != 'ok') {
					console.error('Error in admin ajax call'); vapp.ping(); return;
				}

				this.user_being_edited.rights = new_rights
				this.user_being_edited = null
			});
		},

		is_su(admin_user) {
			return admin_user.su
		},

		can_mimic_all(admin_user) {
			return admin_user.su || admin_user.mimic_all

		},

		can_view_resource_report(admin_user) {
			return admin_user.su || admin_user.res_rep
		},

		get_text(l1, l2) {
			let text

			if (l2 == 'all') {
				text = 'ALL COURSES'
			} else {
				switch(l1) {
					case 'level':
					case 'subject':
						text = 'ALL ' + l2
						break;
					case 'resource_id':
					case 'lesson_id':
						let prefix = l1.split('_')
						text = prefix[0][0].toUpperCase() + prefix[0].slice(1) + ' ' + prefix[1].toUpperCase() + ': ' + l2
						break;
					case 'level_subject':
						let suffix = l2.split('_')
						text = 'GRADE ' + suffix[0] + ' ' + suffix[1]
						break;
					default:
						// lp.course.1355
						let course = this.all_courses.find(x => x.course_code == l2)
						if (!empty(course)) {
							text = course.title
						} else {
							text = 'Course ID ' + l2
						}
				}
			}

			return text
		},

		new_user_clicked() {
			this.$prompt({
				title: 'Add New Admin User',
				text: 'Enter user email:',
				promptType: 'autocomplete',
				serviceName: 'email_search',
				acceptText: 'Add User',
			}).then(email => {
				// return value should be e.g. 'pepper@gmail.com (Pepper Williams)'; extract the email
				email = $.trim(email).toLowerCase().replace(/^(\S+).*/, '$1')

				if (empty(email) || email.indexOf('@') == -1) {
					this.$alert('Please enter a valid user email.').then(x=>{this.new_user_clicked()})
					return
				}
				for (let identifier in this.admin_admin_users) {
					if (this.admin_admin_users[identifier].email.toLowerCase() == email) {
						this.search = email
						this.$alert('This user already has some admin rights. Click the edit button next to the user’s name to edit their rights.')
						return
					}
				}
				this.new_user_validate(email)
			}).catch(n=>{console.error(n)})
		},

		new_user_validate(email) {
			let payload = {
				user_id: this.user_info.user_id,
				email: email,
			}
			U.loading_start()
			U.ajax('admin_validate_email', payload, result=>{
				U.loading_stop()
				if (result.status != 'ok') {
					console.error('Error in admin ajax call'); vapp.ping(); return;
				}

				if (empty(result.user_id)) {
					this.$alert('We couldn’t find that email address in the system.').then(x=>{this.new_user_clicked()})
				} else {
					this.$set(this.admin_admin_users, result.user_id+'', {
						user_id: result.user_id,
						email: result.email,
						first_name: result.first_name,
						last_name: result.last_name,
						rights: [],
					})
					this.user_being_edited = this.admin_admin_users[result.user_id]
				}
			});
		},
	}
}
</script>

<style lang="scss">
</style>
